import { ref } from "vue";

class SessionManager {
  constructor() {
    this.fromName = ref(localStorage.getItem("fromName") || "");
    this.fromId = ref(parseInt(localStorage.getItem("fromId"), 10) || 0);
    this.toName = ref(localStorage.getItem("toName") || "");
    this.toId = ref(parseInt(localStorage.getItem("toId"), 10) || 0);
    this.date = ref(localStorage.getItem("tripDate") || "");
  }

  storeTripDetails(fromName, toName, fromId, toId, date) {
    this.fromName.value = fromName;
    this.toName.value = toName;
    this.fromId.value = fromId;
    this.toId.value = toId;
    this.date.value = date;

    localStorage.setItem("fromName", fromName);
    localStorage.setItem("toName", toName);
    localStorage.setItem("fromId", fromId);
    localStorage.setItem("toId", toId);
    localStorage.setItem("tripDate", date);
  }

  storeBusDetails(bus) {
    const normalized = {
      ...bus,
      trip_date: bus.trip?.trip_date ?? bus.trip_date ?? "",
      trip_route: bus.trip_route
        ? {
            ...bus.trip_route,
            start_point:
              typeof bus.trip_route.start_point === "object"
                ? bus.trip_route.start_point?.name ?? ""
                : bus.trip_route.start_point ?? "",
            end_point:
              typeof bus.trip_route.end_point === "object"
                ? bus.trip_route.end_point?.name ?? ""
                : bus.trip_route.end_point ?? "",
          }
        : bus.trip_route,
    };
    localStorage.setItem("busDetails", JSON.stringify(normalized));
  }

  getBusDetails() {
    return JSON.parse(localStorage.getItem("busDetails"));
  }

  storeBookingDetails(bookingDetails) {
    localStorage.setItem("bookingDetails", JSON.stringify(bookingDetails));
  }

  getBookingDetails() {
    try {
      const data = JSON.parse(localStorage.getItem("bookingDetails"));
      return data?.bookings ?? data;
    } catch {
      return null;
    }
  }

  getBookingExpiresIn() {
    try {
      const data = JSON.parse(localStorage.getItem("bookingDetails"));
      return data?.expires_in_seconds ?? 15 * 60;
    } catch {
      return 15 * 60;
    }
  }

  storePaymentReference(ref) {
    localStorage.setItem("paymentReference", ref);
  }

  getPaymentReference() {
    return localStorage.getItem("paymentReference");
  }

  storeRegions(regions) {
    localStorage.setItem("regions", JSON.stringify(regions));
  }

  getRegions() {
    try {
      const raw = localStorage.getItem("regions");
      if (!raw || raw === "undefined" || raw === "null") return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  storeIdTypes(idTypes) {
    localStorage.setItem("id_types", JSON.stringify(idTypes));
  }

  getIdTypes() {
    return JSON.parse(localStorage.getItem("id_types"));
  }

  storeAgeGroups(ageGroups) {
    localStorage.setItem("age_groups", JSON.stringify(ageGroups));
  }

  getAgeGroups() {
    return JSON.parse(localStorage.getItem("age_groups"));
  }
}

const sessionManager = new SessionManager();
export default sessionManager;
